export const UNIT_PLAYER = 'UnitPlayer';
export const LIST_PLAYER = 'ListPlayer';
export const PRACTICE_PLAYER = 'PracticePlayer';
export const REFRESH_PLAYER = 'RefreshPlayer';
export const GAME_PLAYER = 'GamePlayer';
export const HANDS_FREE_PLAYER = 'HandsFreePlayer';
export const ASSIGNMENT_PLAYER = 'AssignmentPlayer';
export const STANDALONE_ACTIVITY_PLAYER = 'StandaloneActivityPlayer';

export function getPlayerName(): string {
    return (window as any).playerName || UNIT_PLAYER;
}
